import styled from 'styled-components';

export const CTATitle = styled.h2`
  font-size: 2rem;
  color: #fff !important;
  margin-bottom: 20px;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 1.5rem;
    margin-bottom: 15px;
  }
`;

export const CTAText = styled.p`
  font-size: 1.2rem;
  color: #fff;
  margin-bottom: 20px;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 1rem;
    margin-bottom: 15px;
  }
`;

export const CTABlockContainer = styled.div`
  height: 500px;
  width: 100%;
  padding: 1rem;
  position: relative;
  background: radial-gradient(100% 100% at var(--7-x-position) var(--7-y-position), #5d70f6 0%, transparent),
              radial-gradient(100% 100% at var(--8-x-position) var(--8-y-position), #b6bfff 0%, transparent),
              #5d70f6;
  animation-name: main;
  animation-iteration-count: infinite;
  animation-duration: 8s;
  transition-timing-function: ease-in-out;
  backdrop-filter: hue-rotate(220deg);
  line-height: normal;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: 15px;
  margin-top: 5rem;

  @property --7-x-position {
    syntax: '<percentage>';
    inherits: false;
    initial-value: 20%;
  }

  @property --7-y-position {
    syntax: '<percentage>';
    inherits: false;
    initial-value: 80%;
  }

  @property --8-x-position {
    syntax: '<percentage>';
    inherits: false;
    initial-value: 80%;
  }

  @property --8-y-position {
    syntax: '<percentage>';
    inherits: false;
    initial-value: 20%;
  }

  --7-x-position: 20%;
  --7-y-position: 80%;
  --8-x-position: 80%;
  --8-y-position: 20%;

  @keyframes main {
    25% {
      --7-x-position: 15%;
      --7-y-position: 15%;
      --8-x-position: 85%;
      --8-y-position: 80%;
    }
    50% {
      --7-x-position: 80%;
      --7-y-position: 15%;
      --8-x-position: 15%;
      --8-y-position: 85%;
    }
  }

  @media (max-width: 768px) {
    height: 400px;
  }

    &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    min-height: 100%;
    width: 100%;
    background-image: 
    linear-gradient(rgba(93, 112, 246, 0.1) 1px, transparent 1px), 
    linear-gradient(to right, rgba(93, 112, 246, 0.1) 1px, rgba(255, 255, 255, 0) 1px);
    background-position: 0 0, 0 0;
    background-size: 20px 20px, 20px 20px;
    background-repeat: repeat, repeat;
    z-index: -1;
  }
`;